<template>
  <v-container fluid grid-list-sm>
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>
          <span class="font-weight-medium">
            {{ $t('EREPORTER.EXPENSES.ITEM') }}
          </span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark color="indigo" @click="$router.go(-1)">
          {{ $t('BUTTON.BACK') }}
        </v-btn>
        <v-btn
          class="ml-2"
          color="primary"
          @click="
            $router.push({
              name: 'ereporter.amount.edit',
              params: { id: id }
            })
          "
        >
          {{ $t('BUTTON.EDIT') }}
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
    </v-card>
    <v-card class="mt-3" :loading="loading">
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <expense-form
              v-if="Object.keys(expense).length"
              v-model="expense"
              :employee="employee"
              readonly
            ></expense-form>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <expenses-task-list
              class="mt-5 pa-5"
              :reports="expense.reports"
              :total-kilometers="expense.kilometers"
              :total-expenses="expense.expenses"
              @edit="edit"
            ></expenses-task-list>
            <v-dialog
              v-if="dialog"
              v-model="dialog"
              persistent
              max-width="600px"
            >
              <amount-report-form
                :errors="errors.getAll()"
                :amount="amount"
                @isValid="isValid"
                @setAmount="setAmount"
                @update-prop="clearErrorByName($event)"
              >
                <template v-slot:header>
                  <span class="text-h5"
                    >{{ $t('BUTTON.UPDATE') }}
                    {{ $t('EREPORTER.EXPENSES.ITEM') }}
                    {{ $t('EREPORTER.EXPENSES.REPORT') }}
                  </span>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="closeDialog">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>
                <template v-slot:buttons>
                  <v-btn outlined depressed color="grey" @click="closeDialog">
                    {{ $t('BUTTON.CANCEL') }}
                  </v-btn>

                  <v-spacer></v-spacer>
                  <v-btn color="error" depressed @click="remove">
                    {{ $t('BUTTON.DELETE') }}
                  </v-btn>
                  <v-btn
                    color="primary"
                    depressed
                    :disabled="!valid"
                    @click="saveAmount"
                  >
                    {{ $t('BUTTON.UPDATE') }}
                  </v-btn>
                </template>
              </amount-report-form>
            </v-dialog>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <confirm-dialog ref="confirm"></confirm-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';
import ExpenseForm from '../../components/forms/Expenses/ExpenseForm';
import ExpensesTaskList from '../../components/Expenses/ExpensesTaskList';
import errors from '@/modules/_global/mixins/errors';

export default {
  name: 'ExpensesShowPage',

  components: {
    AmountReportForm: () =>
      import('@/modules/ereporter/components/forms/Expenses/AmountReportForm'),
    ConfirmDialog: () => import('@/modules/_global/_components/ConfirmDialog'),
    ExpenseForm,
    ExpensesTaskList
  },

  mixins: [i18nRefreshData, errors],

  props: {
    id: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    expense: {},
    employee: {},
    dialog: false,
    reportId: null,
    amount: null,
    editedAmount: null
  }),

  computed: {
    ...mapGetters(['loading']),
    ...mapState('ereporter', ['currentInvoice'])
  },

  mounted() {
    this.refreshData();
  },

  methods: {
    ...mapActions('ereporter', [
      'getExpense',
      'updateAmountReport',
      'removeAmount'
    ]),
    refreshData() {
      this.getExpense({ expenseId: this.id })
        .then(({ data }) => {
          this.expense = data;
          this.employee = data.employee;
        })
        .catch(({ response }) => {
          console.log(response);
          this.expense.reports = [];
        });
    },
    show(item) {
      this.$router.push({
        name: 'ereporter.amount.show',
        params: { id: item.id }
      });
    },
    closeDialog() {
      (this.amount = null),
        (this.dialog = false),
        this.errors.clear('kilometers'),
        this.errors.clear('expenses');
    },
    isValid(val) {
      this.valid = val;
    },
    edit(item) {
      this.amount = item;
      this.dialog = true;
      this.valid = true;
    },
    setAmount(val) {
      this.editedAmount = val;
    },
    saveAmount() {
      this.updateAmountReport({ amount: this.editedAmount })
        .then(() => {
          this.closeDialog();
          this.refreshData();
        })
        .catch(({ response }) => {
          this.handleErrorsByResponse(response);
        });
    },
    remove() {
      this.$refs.confirm
        .open(this.$t('MESSAGE.REALLY_WANT_TO_REMOVE'), null, {
          cancelBtnText: this.$t('BUTTON.CANCEL'),
          agreeBtnText: this.$t('BUTTON.DELETE'),
          agreeBtnColor: 'error'
        })
        .then(confirm => {
          if (confirm) {
            this.removeAmount(this.amount.id);
            this.closeDialog();
          }
        })
        .finally(() => {
          if (this.expense.reports.length > 1) {
            this.refreshData();
          } else {
            this.$router.push({
              name: 'expenses'
            });
          }
        });
    }
  }
};
</script>

<style scoped></style>
